import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { imgTema6 } from '../../../assets/tema6';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	dialogEleven: 12,
	dialogTwelve: 13,
	dialogThirteen: 14,
	dialogFourteen: 15,
	dialogFifteen: 16,
	dialogSixteen: 17,
	win: 20,
	hideUI: 100,
};

const stepThree = {
	move_pinpad: {
		ui: steps.hideUI,
		action: () => {

		}
	},
	move_keyboard: {
		ui: steps.dialogEight,
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a08)
		}
	},
}

export const Theme6SubtopicTwoActivityTwo = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema6.activities.subtema2], 2);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 6 sub 2 act 2");
			ObserverEmitter.emit(EVENTS.tema6.topic2.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a01)
	})

	ObserverEmitter.on(EVENTS.tema6.topic2.listenScene, (step = "") => {
		const valuesObj = stepThree[step]
		if (!valuesObj) {
			return
		}
		valuesObj.action()
		setUiToShow(valuesObj.ui)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, 100].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema6.topic2.initScene, 2);
						ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "reboot_2");
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 2: Simulación con cliente." />
					<DialogBarNew
						dialog={`Veamos, cómo lo aplicaríamos con nuestro Cliente.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2. Tiempo Aire Electrónico (TAE)"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "move_client");
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<ViewPerson img={imgTema6.Anahi_feliz} />
					<DialogBarNew
						name='Anahí'
						dialog={`¿Me podría indicar su compañía de teléfono?`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a03)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<ViewPerson img={imgTema6.Yonny_tranqui} />
					<DialogBarNew
						name='Yonny'
						dialog={`Es Movistar, por favor.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a04)
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "move_monitor");
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "texture_monitor_1");
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={`Selecciona la "Compañía telefónica".`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a05)
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "move_client");
							setUiToShow(steps.dialogFive);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<ViewPerson img={imgTema6.Anahi_feliz} />
					<DialogBarNew
						name='Anahí'
						dialog={`¿De cuánto sería la recarga?`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a06)
							setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<ViewPerson img={imgTema6.Yonny_tranqui} />
					<DialogBarNew
						name='Yonny'
						dialog={`Sería de $50 pesos por favor. Aquí tiene mi tarjeta.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a07)
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<ViewPerson img={imgTema6.Anahi_feliz} />
					<DialogBarNew
						name='Anahí'
						dialog={`Coloque su tarjeta en la terminal por favor.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "animation_pinpad");
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEight && (
				<>
					<DialogBarNew
						dialog={`Selecciona la tecla “T” cuando se realice un pago con tarjeta.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a09)
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "move_monitor");
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "texture_monitor_2");
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "remove_animations");
							setUiToShow(steps.dialogNine);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogNine && (
				<>
					<DialogBarNew
						dialog={`Selecciona la cantidad de la recarga solicitada.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a10)
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "move_client");
							setUiToShow(steps.dialogTen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTen && (
				<>
					<ViewPerson img={imgTema6.Anahi_feliz} />
					<DialogBarNew
						name='Anahí'
						dialog={`¿Me podría proporcionar su número, por favor?`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a11)
							setUiToShow(steps.dialogEleven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEleven && (
				<>
					<ViewPerson img={imgTema6.Yonny_tranqui} />
					<DialogBarNew
						name='Yonny'
						dialog={`Claro, es el (81) 00 00 00 01.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a12)
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "move_monitor");
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "texture_monitor_3");
							setUiToShow(steps.dialogTwelve);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwelve && (
				<>
					<DialogBarNew
						dialog={`Ingresa el número de celular del cliente.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a13)
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "move_client");
							setUiToShow(steps.dialogThirteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThirteen && (
				<>
					<ViewPerson img={imgTema6.Anahi_feliz} />
					<DialogBarNew
						name='Anahí'
						dialog={`¿Me lo podría repetir, por favor?`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a14)
							setUiToShow(steps.dialogFourteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFourteen && (
				<>
					<ViewPerson img={imgTema6.Yonny_tranqui} />
					<DialogBarNew
						name='Yonny'
						dialog={`Claro, es el (81) 00 00 00 01.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a15)
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "move_monitor");
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "texture_monitor_4");
							setUiToShow(steps.dialogFifteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFifteen && (
				<>
					<DialogBarNew
						dialog={`Haz clic en 'Aceptar' una vez que hayas confirmado el número telefónico.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act2_a16)
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "move_client");
							setUiToShow(steps.dialogSixteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSixteen && (
				<>
					<ViewPerson img={imgTema6.Anahi_ticket} />
					<DialogBarNew
						name='Anahí'
						dialog={`Aquí tiene su ticket, ¡Vuelva Pronto!`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "move_desk");
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.hideUI && (
				<>

				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Realizaste con éxito el proceso de TAE."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 0,
									subtema: tasksId.tema6.activities.subtema2
								})
							);
							navigator("/home6/tema6/subtema2/activityThree");
						}}
					/>
				</>
			)}
		</>
	)
}


const ViewPerson = ({ img = "" }) => {
	return (
		<>
			<div className='fixed h-full w-full bg-[#00000074] flex justify-center items-center'>
				<div className='w-[250px] h-[250px] md:w-[500px] md:h-[500px]'>
					<img className='h-full w-full object-contain' src={img} alt="person" />
				</div>
			</div>
		</>
	)
}